import { useCreateSoftwareVersionMutation } from "../../api/api-hooks";
import { SoftwareVersionForm } from "./linksTypes";

const useSoftwareVersionCreator = () => {
  const [createVersion] = useCreateSoftwareVersionMutation();
  return (item: SoftwareVersionForm) => {
    if (
      item.software === null ||
      item.software === undefined ||
      item.operatingSystem === null ||
      item.operatingSystem === undefined ||
      !item.versionNumber ||
      !item.link
    )
      return { error: { data: { message: "Missing required fields" } } };
    return createVersion({
      createSoftwareVersionDto: {
        versionNumber: item.versionNumber,
        versionType: item.versionType,
        link: item.link,
        changelog: item.changelog,
        size: Number(item.size),
        softwareId: item.software.id,
        operatingSystemsId: item.operatingSystem.id,
        userguideName: item.userguideName,
        userguideLink: item.userguideLink,
      },
    });
  };
};

export default useSoftwareVersionCreator;
